import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "button"]

  connect() {
    this.updateButtonState()
  }

  updateButtonState() {
    const selectedOption = this.optionTargets.find((option) => option.checked)

    if (selectedOption) {
      const targetUrl = selectedOption.dataset.url
      this.buttonTarget.href = targetUrl
      // For link-based buttons, we usually toggle a class
      this.buttonTarget.classList.remove("disabled")
    } else {
      this.buttonTarget.href = "#"
      this.buttonTarget.classList.add("disabled")
    }
  }

  selectOption() {
    this.updateButtonState()
  }
}
